import { render } from "./UiSkeleton.vue?vue&type=template&id=4ad338fe"
import script from "./UiSkeleton.vue?vue&type=script&lang=js"
export * from "./UiSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__